var Haiku = require("@haiku/core");
var _code_circle_code = require("./../circle/code.js");
module.exports = {
  metadata: {
    version: "0.0.3",
    username: "tina@haiku.ai",
    organization: "Tina",
    project: "AnimatorWebsiteIcon2",
    branch: "master",
    folder: "/Users/agustina/.haiku/projects/Tina/AnimatorWebsiteIcon2",
    uuid: "67a900ef-ed0f-491d-bee4-d8a023cf6ea0",
    root: "https://cdn.haiku.ai/9fec979d-d44c-4994-b16b-ee78d60c5e95/5f95a2978fb21498c9f76103836200625255c63b/",
    core: "4.5.0",
    title: "Main",
    type: "haiku",
    relpath: "code/main/code.js"
  },
  options: {},
  states: { play: { type: "string", value: "stop", edited: true } },
  eventHandlers: {
    "haiku:Main-03757d2ca1026e0a": {
      hover: {
        handler: function(component, element, target, event) {
          this.setState({ play: "loop" });
        }
      },
      unhover: {
        handler: function(component, element, target, event) {
          this.setState({ play: "stop" });
        }
      }
    }
  },
  timelines: {
    Default: {
      "haiku:Main-03757d2ca1026e0a": {
        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
        "style.position": "relative",
        "style.overflowX": "hidden",
        "style.overflowY": "hidden",
        "sizeAbsolute.x": 100.402,
        "sizeAbsolute.y": 81.872,
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeMode.z": 1
      },
      "haiku:Cog-Icon-f30f200d0748e297": {
        "style.position": "absolute",
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 41,
        "sizeMode.x": 1,
        "sizeAbsolute.y": 38,
        "sizeMode.y": 1,
        "translation.x": 50.5,
        "translation.y": 40.899993896484375,
        "style.zIndex": 2
      },
      "haiku:Linear-Gradient-1-5ecbc7-e32da9ac9ce0d616": {
        x1: "21.6215522%",
        y1: "15.3187264%",
        x2: "50%",
        y2: "94.1878588%"
      },
      "haiku:Stop-7d22cd2176cbbf69": { stopColor: "#04B6CB", offset: "0%" },
      "haiku:Stop-cda765f4f066c2f2": { stopColor: "#A3CE32", offset: "100%" },
      "haiku:Linear-Gradient-2-5ecbc7-ffda7821e90a14fb": {
        x1: "21.6215522%",
        y1: "10.7570105%",
        x2: "50%",
        y2: "100%"
      },
      "haiku:Stop-f187087d3d09e249": { stopColor: "#04B6CB", offset: "0%" },
      "haiku:Stop-f2e1a2b5fe3f15fd": { stopColor: "#A3CE32", offset: "100%" },
      "haiku:Page-1-25d2b85c05c9524d": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:Haiku-Core-Icon-fcc961643b954a64": {
        fillRule: "nonzero",
        "translation.x": -10,
        "translation.y": -12
      },
      "haiku:Cog-Icon-1162f9ddfaf1a8ef": {
        "translation.x": 10.3,
        "translation.y": 11.8
      },
      "haiku:Shape-c7f11c1e365d4a4c": {
        d:
          "M26.648,37.804 C26.5,37.804 26.352,37.772 26.216,37.706 C25.97,37.588 25.784,37.376 25.698,37.118 C24.884,34.656 22.594,33.002 20,33.002 C17.406,33.002 15.114,34.656 14.302,37.118 C14.216,37.376 14.03,37.588 13.784,37.706 C13.538,37.824 13.256,37.836 13.002,37.742 C10.918,36.964 8.99,35.848 7.272,34.43 C7.062,34.256 6.932,34.006 6.912,33.736 C6.892,33.466 6.982,33.198 7.162,32.994 C8.886,31.058 9.174,28.25 7.876,26.002 C6.808,24.152 4.814,23.002 2.674,23.002 C2.268,23.002 1.86,23.044 1.464,23.126 C1.198,23.182 0.92,23.126 0.696,22.972 C0.472,22.818 0.32,22.58 0.274,22.312 C0.092,21.22 0,20.108 0,19.004 C0,17.9 0.092,16.788 0.274,15.696 C0.318,15.428 0.47,15.19 0.696,15.036 C0.922,14.882 1.198,14.826 1.464,14.882 C1.86,14.964 2.268,15.006 2.674,15.006 C4.814,15.006 6.808,13.856 7.876,12.006 C9.172,9.76 8.886,6.95 7.162,5.014 C6.982,4.812 6.89,4.544 6.912,4.272 C6.934,4 7.062,3.75 7.272,3.578 C8.99,2.158 10.92,1.044 13.002,0.266 C13.256,0.17 13.54,0.184 13.784,0.302 C14.028,0.42 14.216,0.632 14.302,0.89 C15.116,3.352 17.406,5.006 20,5.006 C22.594,5.006 24.886,3.352 25.698,0.89 C25.784,0.632 25.97,0.42 26.216,0.302 C26.462,0.184 26.744,0.172 26.998,0.266 C29.082,1.044 31.01,2.16 32.728,3.578 C32.938,3.752 33.068,4.002 33.088,4.272 C33.108,4.542 33.018,4.81 32.838,5.014 C31.114,6.95 30.826,9.758 32.124,12.006 C33.192,13.858 35.186,15.006 37.326,15.006 C37.732,15.006 38.14,14.964 38.536,14.882 C38.802,14.826 39.08,14.882 39.304,15.036 C39.528,15.19 39.68,15.428 39.726,15.696 C39.908,16.788 40,17.9 40,19.004 C40,20.108 39.908,21.22 39.726,22.312 C39.682,22.58 39.53,22.818 39.304,22.972 C39.078,23.126 38.802,23.182 38.536,23.126 C38.14,23.044 37.732,23.002 37.326,23.002 C35.186,23.002 33.192,24.152 32.124,26.002 C30.828,28.248 31.114,31.058 32.838,32.994 C33.018,33.196 33.11,33.464 33.088,33.736 C33.066,34.008 32.938,34.258 32.728,34.43 C31.01,35.85 29.082,36.964 26.998,37.742 C26.884,37.784 26.766,37.806 26.648,37.806 L26.648,37.804 Z M9.308,33.482 C10.396,34.286 11.564,34.962 12.802,35.502 C14.126,32.772 16.9,31 20,31 C23.1,31 25.874,32.772 27.198,35.502 C28.436,34.962 29.604,34.286 30.692,33.482 C28.99,30.97 28.844,27.684 30.392,25 C31.816,22.532 34.474,21 37.326,21 C37.512,21 37.7,21.006 37.886,21.02 C37.962,20.348 38,19.672 38,19.002 C38,18.332 37.962,17.654 37.886,16.984 C37.7,16.998 37.512,17.004 37.326,17.004 C34.474,17.004 31.816,15.472 30.392,13.004 C28.842,10.32 28.988,7.032 30.692,4.522 C29.604,3.718 28.436,3.042 27.198,2.502 C25.874,5.232 23.1,7.004 20,7.004 C16.9,7.004 14.126,5.232 12.802,2.502 C11.564,3.042 10.396,3.718 9.308,4.522 C11.01,7.034 11.156,10.32 9.608,13.004 C8.184,15.472 5.526,17.004 2.674,17.004 C2.488,17.004 2.3,16.998 2.114,16.984 C2.038,17.656 2,18.332 2,19.002 C2,19.672 2.038,20.35 2.114,21.02 C2.3,21.006 2.488,21 2.674,21 C5.526,21 8.184,22.534 9.608,25 C11.158,27.684 11.012,30.972 9.308,33.482 Z",
        fill: "url(#linearGradient-1-5ecbc7)"
      },
      "haiku:Shape-8ddb638da94880d0": {
        d:
          "M20,25 C16.692,25 14,22.308 14,19 C14,15.692 16.692,13 20,13 C23.308,13 26,15.692 26,19 C26,22.308 23.308,25 20,25 Z M20,15 C17.794,15 16,16.794 16,19 C16,21.206 17.794,23 20,23 C22.206,23 24,21.206 24,19 C24,16.794 22.206,15 20,15 Z",
        fill: "url(#linearGradient-2-5ecbc7)"
      },
      "haiku:Circle-2dba6ebd7b0693fc": {
        "style.position": "absolute",
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeAbsolute.x": "auto",
        "sizeAbsolute.y": "auto",
        "translation.x": 50.201,
        "translation.y": 41.03600000000001,
        "sizeMode.z": 1,
        "origin.x": 0.5,
        "origin.y": 0.5,
        "style.zIndex": 1,
        playback: {
          "0": {
            value: Haiku.inject(function(play) {
              return play;
            }, "play"),
            edited: true
          }
        },
        PlayIt: {
          "0": {
            value: Haiku.inject(function(play) {
              return play;
            }, "play"),
            edited: true
          }
        }
      }
    }
  },
  template: {
    elementName: "div",
    attributes: { "haiku-id": "Main-03757d2ca1026e0a", "haiku-title": "Main" },
    children: [
      {
        elementName: _code_circle_code,
        attributes: {
          "haiku-id": "Circle-2dba6ebd7b0693fc",
          "haiku-var": "_code_circle_code",
          "haiku-title": "Circle",
          "haiku-source": "./code/circle/code.js"
        },
        children: []
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Cog-Icon-f30f200d0748e297",
          "haiku-title": "Cog icon",
          "haiku-source":
            "designs/AnimatorWebsiteIcon2.sketch.contents/slices/Cog icon.svg"
        },
        children: [
          {
            elementName: "defs",
            attributes: { "haiku-id": "Defs-d32f24d4442ff82f" },
            children: [
              {
                elementName: "linearGradient",
                attributes: {
                  "haiku-id": "Linear-Gradient-1-5ecbc7-e32da9ac9ce0d616",
                  id: "linearGradient-1-5ecbc7"
                },
                children: [
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-7d22cd2176cbbf69" },
                    children: []
                  },
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-cda765f4f066c2f2" },
                    children: []
                  }
                ]
              },
              {
                elementName: "linearGradient",
                attributes: {
                  "haiku-id": "Linear-Gradient-2-5ecbc7-ffda7821e90a14fb",
                  id: "linearGradient-2-5ecbc7"
                },
                children: [
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-f187087d3d09e249" },
                    children: []
                  },
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-f2e1a2b5fe3f15fd" },
                    children: []
                  }
                ]
              }
            ]
          },
          {
            elementName: "g",
            attributes: { "haiku-id": "Page-1-25d2b85c05c9524d", id: "Page-1" },
            children: [
              {
                elementName: "g",
                attributes: {
                  "haiku-id": "Haiku-Core-Icon-fcc961643b954a64",
                  id: "HaikuCore-icon"
                },
                children: [
                  {
                    elementName: "g",
                    attributes: {
                      "haiku-id": "Cog-Icon-1162f9ddfaf1a8ef",
                      id: "Cog-icon"
                    },
                    children: [
                      {
                        elementName: "path",
                        attributes: {
                          "haiku-id": "Shape-c7f11c1e365d4a4c",
                          id: "Shape"
                        },
                        children: []
                      },
                      {
                        elementName: "path",
                        attributes: {
                          "haiku-id": "Shape-8ddb638da94880d0",
                          id: "Shape"
                        },
                        children: []
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/@haiku/tina-animatorwebsiteicon2/code/main/code.js
// module id = 435
// module chunks = 35783957827783